import { render, staticRenderFns } from "./RuleDeviationsModal.vue?vue&type=template&id=7dda548d"
import script from "./RuleDeviationsModal.vue?vue&type=script&lang=js"
export * from "./RuleDeviationsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports